export const FEATURE_LABELS = {
  "AI-R1": "Worker shift matching",
  "AI-R2": "Overlap resolution",
  "AI-R3": "No-show prediction",
  "AI-R4": "Timesheet anomaly check",
  "AI-R4-bulk": "Timesheet anomaly check Bulk",
  "AI-R5": "Invoice code suggestion",
  "AI-R6": "Roster optimization",
  "AI-CN1": "COS case note assist",
  "AI-CN2": "Case note quality score",
  "AI-CN3": "Timesheet draft note",
  "AI-CN3-stream": "Timesheet draft note (stream)",
  "AI-PW1": "Vertex360 Copilot",
  "AI-PW1-stream": "Vertex360 Copilot",
  "AI-EMBED": "Vertex360 Copilot",
  "AI-EMBED-SEARCH": "Vertex360 Copilot",
  "AI-EMBED-BULK": "Vertex360 Copilot",
  timesheet_anomaly_detection: "Timesheet anomaly check",
  timesheet_draft_note: "Timesheet draft note",
  case_note_draft: "Case note draft",
  case_note_quality: "Case note quality",
  embedding: "Vertex360 Copilot",
  copilot: "Vertex360 Copilot",
};

// Internal identifiers that must never reach a service provider: prompt names,
// model ids, provider names, embedding plumbing. A customer's bill should name
// the feature they used, not the plumbing that served it.
const INTERNAL_NAME =
  /^(vertex360_|copilot_|AI-EMBED)|_copilot_|^gpt-|^o[34]|^openai/i;

/**
 * Collapse raw feature codes into deduplicated user-facing filter options.
 *
 * Multiple codes map to the same label (e.g. AI-PW1, AI-EMBED → "Vertex360
 * Copilot"). The dropdown should show one entry per label, and the value is
 * the comma-joined list of raw codes so the backend can match any of them.
 */
export const buildFeatureFilterOptions = (rawFeatures = []) => {
  const seen = new Map();

  for (const code of rawFeatures) {
    const label = FEATURE_LABELS[code]
      || (typeof code === "string" && INTERNAL_NAME.test(code) ? "Vertex360 Copilot" : null);

    if (!label) continue;

    if (seen.has(label)) {
      seen.get(label).codes.push(code);
    } else {
      seen.set(label, { label, codes: [code] });
    }
  }

  return Array.from(seen.values()).map((entry) => ({
    value: entry.codes[0],
    codes: entry.codes,
    label: entry.label,
  }));
};

export const formatFeatureLabel = (row) => {
  if (row?.analysis_origin === "bulk" && (row?.feature === "AI-R4" || !row?.feature)) {
    return "Timesheet anomaly check Bulk";
  }
  const raw =
    row?.feature ||
    row?.prompt_name ||
    row?.domain ||
    row?.feature_key ||
    "AI request";
  if (FEATURE_LABELS[raw]) return FEATURE_LABELS[raw];
  if (typeof raw === "string" && INTERNAL_NAME.test(raw)) {
    // Unmapped internal name — say what the customer did, not how.
    return "Vertex360 Copilot";
  }
  if (typeof raw === "string" && raw.startsWith("AI-")) return raw;
  return String(raw).replace(/_/g, " ");
};
